/*
 * @Author: Teemo Ding
 * @Date: 2022-04-20 17:51:17
 * @LastEditTime: 2022-04-21 10:06:27
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/Components/SelectAll/index.tsx
 */
import { Checkbox } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const SelectAll = ({ value, onChange, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [storeRoles = [], salesChannelRoles = []] = value || [];
  const allSalesChannelOptions = salesChannelRoles.flatMap(
    (item) => item.roles,
  );
  const allOptions = storeRoles.concat(allSalesChannelOptions);

  const plainOptions = (allOptions || []).map((item) => get(item, 'role.name'));
  const checkedList = (allOptions || [])
    .filter((o) => o.checked)
    .map((item) => get(item, 'role.name'));

  const indeterminate =
    !!checkedList.length && checkedList.length !== plainOptions.length;
  const checkAll =
    !!checkedList.length && checkedList.length === plainOptions.length;
  return (
    <Checkbox
      indeterminate={indeterminate}
      onChange={onChange}
      disabled={disabled}
      className={css.checkAll}
      checked={checkAll}>
      {getI18n('usersAndPermissions.detail.selectAll')}
    </Checkbox>
  );
};

export default SelectAll;
